class JobMatchMeetingsFeedbackModalController {
    constructor() {
        // this.jobMatchId = this.resolve.jobMatchId
        // this.jobId = this.resolve.jobId;
        // this.candidateId = this.resolve.candidateId;
        // this.feedbackType = this.resolve.feedbackType;
        // this.meetingUserList = this.resolve.meetingUserList;
        // this.parentScheduleId = this.resolve.parentScheduleId;
        // this.childScheduleId = this.resolve.childScheduleId;
    }
    $onInit() {
        this.jobMatchId = this.resolve.jobMatchId;
        this.jobId = this.resolve.jobId;
        this.candidateId = this.resolve.candidateId;
        this.feedbackType = this.resolve.feedbackType;
        this.meetingUserList = this.resolve.meetingUserList;
        this.parentScheduleId = this.resolve.parentScheduleId;
        this.childScheduleId = this.resolve.childScheduleId;
        this.callbackObject = { callbackType: 'cancel', entity: {} };
        this.feedbackUserIdsList = [];
        this.title = 'Interview Feedback';
        if (this.feedbackType == 'PhoneScreen') {
            this.title = 'Phone Screen Feedback';
            this.workflowStep = 'ps';
        }
        else {
            this.workflowStep = 'in';
        }
        angular.forEach(this.meetingUserList, (val, key) => {
            this.feedbackUserIdsList.push(val.userId);
        });
    }
    closeModal() {
        this.modalInstance.close(this.callbackObject);
    }
    dismissModal() {
        this.modalInstance.dismiss('cancel');
    }
    refresh() {
        this.callbackObject.callbackType = 'refresh';
        this.modalInstance.close(this.callbackObject);
    }
}
// import * as TEMPLATE from './job-match-meetings-feedback-modal.html;
import * as TEMPLATE from 'raw-loader!./job-match-meetings-feedback-modal.html';
export const JobMatchMeetingsFeedbackModalComponent = {
    selector: 'jobMatchMeetingsFeedbackModal',
    component: {
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controller: JobMatchMeetingsFeedbackModalController,
        template: TEMPLATE.default
        // templateUrl: 'app/shared/jobMatchActions/jobMatchMeetings/jobMatchMeetingsFeedbackModal/job-match-meetings-feedback-modal.html'
    }
};
//# sourceMappingURL=job-match-meetings-feedback-modal.component.js.map